function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import L from 'leaflet';
function toGeoJSONFeature(layer, decimals) {
  const feature = layer.toGeoJSON();
  let shape;
  const extraProperties = {};
  if (layer instanceof L.Circle) {
    shape = 'circle';
    extraProperties.radius = layer.getRadius(); // in meters
  } else if (layer instanceof L.Rectangle) {
    shape = 'rectangle';
  } else if (layer instanceof L.Polygon) {
    shape = 'polygon';
  } else if (layer instanceof L.Polyline) {
    shape = 'polyline';
  } else if (layer instanceof L.Marker) {
    shape = 'marker';
  }
  if (shape) {
    var _feature$properties;
    feature.properties = _objectSpread(_objectSpread({}, (_feature$properties = feature.properties) !== null && _feature$properties !== void 0 ? _feature$properties : {}), {}, {
      shape
    }, extraProperties);
  }

  // Round coordinates to specified decimals
  const roundedFeature = JSON.parse(JSON.stringify(feature, (_key, val) => {
    if (Array.isArray(val) && typeof val[0] === 'number') {
      return val.map(v => Number(v.toFixed(decimals)));
    }
    return val;
  }));
  return roundedFeature;
}
function deepTranslate(target, t, prefix) {
  if (typeof target === 'string') {
    return t(prefix);
  }
  if (typeof target !== 'object' || target === null) {
    return target;
  }
  const result = Array.isArray(target) ? [] : {};
  for (const key in target) {
    result[key] = deepTranslate(target[key], t, `${prefix}.${key}`);
  }
  return result;
}
export { toGeoJSONFeature, deepTranslate };